module.exports = __webpack_public_path__ + "img/Motor_Acc_1.8fc5db1e.jpg";